import React, { Fragment } from 'react'
import moment from 'moment'
import {
  defaultPageSize,
  pageSizeOptions,
  showSizeChanger,
  Table,
  IColumnProps,
  Toggle,
  Button,
  Form,
  FormItem,
  Modal,
  AsumsiIcon,
  Tooltip
} from "asumsi-components"
import { useState } from "react"
import { INewsMedia, IResponseNewsCrawler, IResponseNewsCrawlerDetail, ITopic } from '@interfaces/iresponse-news-crawler'
import { Button as AntdButton, Input, Select } from 'antd'
import { IMetaData } from '@interfaces/imeta-data'
import { IParamUpdateNewsCrawler } from '@interfaces/iparam-news-crawler'
import { NewsCrawlerDetail } from './detail'

const { TextArea } = Input
const { Option } = Select;
type Props = {
  dataSource: IResponseNewsCrawler[]
  metaData: IMetaData
  onChangeTable: (pagination: any, _: any, sorter: any) => void
  onPublish: () => void
  onUnpublish: () => void
  onChangeReason: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  loading: boolean
  selectedRow: string[]
  setSelectedRow: React.Dispatch<React.SetStateAction<string[]>>
  updateNewsCrawlerValues: IParamUpdateNewsCrawler
  onChangeId: (id: string[]) => void
  setUpdateNewsCrawlerValues: React.Dispatch<IParamUpdateNewsCrawler>
  getDetail: (id: string) => Promise<void>
  detail: IResponseNewsCrawlerDetail
  onCancelUpdate: Function
  topics: ITopic[]
  onCancelToggle: Function
  fetchTopicList: (value?: string) => Function
}

export default function (props: Props) {
  const {
    dataSource,
    metaData,
    onChangeTable,
    loading,
    onPublish,
    onUnpublish,
    onChangeReason,
    setSelectedRow,
    selectedRow,
    updateNewsCrawlerValues,
    setUpdateNewsCrawlerValues,
    onChangeId,
    getDetail,
    detail,
    onCancelUpdate,
    topics,
    onCancelToggle,
    fetchTopicList
  } = props

  const topicsOptions = topics.map((topic: ITopic) => <Option key={topic.id} value={topic.id}>{topic.name}</Option>)

  const [showConfirmPublish, setShowConfirmPublish] = useState(false)
  const [showConfirmUnpublish, setShowConfirmUnpublish] = useState(false)
  const [showDetail, setShowDetail] = useState(false)

  const onToggleChange = (id: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowConfirmPublish(e.target.checked)
    setShowConfirmUnpublish(!e.target.checked)
    onChangeId([id])
  }

  const onShowDetail = (id: string) => (e: any) => {
    getDetail(id)
    onChangeId([id])
    setShowDetail(true)
  }

  const columns: IColumnProps[] = [
    {
      dataIndex: 'title',
      key: 'title',
      title: 'TITLE',
      textAlign: 'left',
      alignData: 'left',
      columnWidht: '22%',
      sorter: true,
      render: (text: string, record: IResponseNewsCrawler) => (
        <span className="content-url" onClick={onShowDetail(record.id)} style={{ cursor: 'pointer' }}>{text}</span>
      )
    },
    {
      dataIndex: 'url',
      key: 'url',
      title: 'URL',
      textAlign: 'left',
      alignData: 'left',
      columnWidht: '25%',
      sorter: true,
      render: (text: string) => <a href={text} className="content-url" target="__blank">{text}</a>
    },
    {
      dataIndex: 'newsMedia',
      key: 'newsMedia',
      title: 'SOURCE',
      textAlign: 'left',
      alignData: 'left',
      columnWidht: '10%',
      sorter: true,
      render: (newsMedia: INewsMedia) => newsMedia.name
    },
    {
      dataIndex: 'postedDate',
      key: 'postedDate',
      title: 'POSTED DATE',
      textAlign: 'left',
      alignData: 'left',
      columnWidht: '13%',
      sorter: true,
      render: (date: string) => date ? moment(new Date(date)).format('DD MMM yyyy') : '-'
    },
    {
      dataIndex: 'publishedAt',
      key: 'publishedAt',
      title: 'PUBLISHED DATE',
      textAlign: 'left',
      alignData: 'left',
      columnWidht: '13%',
      sorter: true,
      render: (date: string, record: IResponseNewsCrawler) => date ? (
        <div>
          <span>{moment(new Date(date)).format('DD MMM yyyy')}</span>
          {
            record.unpublishedReason && (
              <Tooltip text={record.unpublishedReason}>
                <AntdButton type="link">
                  <AsumsiIcon className="content-url" icon="help" />
                </AntdButton>
              </Tooltip>
            )
          }
        </div>
      ) : (
          <span>-</span>
        )
    },
    {
      dataIndex: 'topics',
      key: 'topics',
      title: 'TOPIC',
      sorter: true,
      columnWidht: "10%",
      render: (topics: ITopic[]) => {
        if (topics.length === 0) return (
          <span>-</span>
        )

        return topics.map((item, index) => index === 0 ? (
          <span key={item.id}>{item.name}</span>
        ) : (
            <span key={item.id}>, {item.name}</span>
          ))
      }
    },
    {
      dataIndex: 'status',
      key: 'status',
      title: 'PUBLISHED?',
      textAlign: 'center',
      alignData: 'center',
      render: (status: string, record: IResponseNewsCrawler) => {
        return (
          <div className="bt-table__action">
            <Toggle onChange={onToggleChange(record.id)} defaultChecked={status == "published"} />
          </div>
        );
      },
    },
  ]

  const additionalAction = <div className="additional-top-action">
    <Button
      className="m-r-5"
      type="outline-red"
      size="small"
      text="Bulk Unpublish"
      onClick={() => {
        setShowConfirmUnpublish(true)
        onChangeId(selectedRow)
      }}
    />
    <Button
      type="outline-green"
      size="small"
      text="Bulk Publish"
      onClick={() => {
        setShowConfirmPublish(true)
        onChangeId(selectedRow)
      }}
    />
  </div>

  const onChangeTopic = (value: string) => {
    if (!value) {
      fetchTopicList();
    }

    setUpdateNewsCrawlerValues({ ...updateNewsCrawlerValues, topicId: value });
  }

  return (
    <Fragment>
      <Table columns={columns}
        dataSource={dataSource}
        className="asumsi-table"
        loading={loading}
        pagination={{
          currentPage: metaData.page,
          defaultPageSize: metaData ? metaData.limit : defaultPageSize,
          pageSizeOptions,
          showSizeChanger,
          total: metaData.totalRecords,
        }}
        rowKey="id"
        onChange={onChangeTable}
        rowSelection={{
          rowSelected: selectedRow,
          setRowSelectedValues: setSelectedRow
        }}
        additionalActionOnTop={additionalAction}
      ></Table>

      <Modal
        show={showConfirmPublish}
        setShow={setShowConfirmPublish}
        title="Publish"
        onOk={onPublish}
        okText="Publish"
        cancelText="Cancel"
        onCancel={onCancelUpdate}
        actionBottom={true}
      >
        <Form className="m-r-20 m-l-20 m-t-10">
          <p>
            Are you sure you want to publish selected posts?
            All of selected posts will be published immediately.
          </p>
          <FormItem
            fieldsValues={updateNewsCrawlerValues}
            fieldDecorator={{
              label: 'topicId',
              rules: [{
                message: 'Please select topic',
                required: true
              }]
            }}
            label="Topic"
            setFieldsValues={setUpdateNewsCrawlerValues}
          >
            <Select
              id="topicId"
              style={{ width: "100%" }}
              allowClear
              onSearch={fetchTopicList}
              showSearch
              optionFilterProp="children"
              defaultValue={updateNewsCrawlerValues.topicId}
              value={updateNewsCrawlerValues.topicId}
              onChange={onChangeTopic}
              placeholder="Please select topic"
            >
              {topicsOptions}
            </Select>
          </FormItem>
        </Form>
      </Modal>

      <Modal
        show={showConfirmUnpublish}
        setShow={setShowConfirmUnpublish}
        title="Unpublish"
        onOk={onUnpublish}
        okText="Unpublish"
        cancelText="Cancel"
        actionBottom={true}
        onCancel={onCancelToggle}
      >
        <Form className="m-r-20 m-l-20 m-t-10">
          <p>
            Are you sure you want to unpublish selected posts?
            All of selected posts will be unpublished immediately.
          </p>
          <FormItem
            label="Reason"
          >
            <TextArea
              placeholder="Reason of unpublish"
              className="width-100"
              allowClear={false}
              rows={5}
              onChange={onChangeReason}
              value={updateNewsCrawlerValues.reason}
            />
          </FormItem>
        </Form>
      </Modal>

      <NewsCrawlerDetail
        detail={detail}
        loading={loading}
        showDetail={showDetail}
        setShowDetail={setShowDetail}
        fieldValues={updateNewsCrawlerValues}
        topicsOptions={topicsOptions}
        setFieldValues={setUpdateNewsCrawlerValues}
        onChangeReason={onChangeReason}
        onPublish={onPublish}
        onUnpublish={onUnpublish}
        onCancelUpdate={onCancelUpdate}
        fetchTopicList={fetchTopicList}
      />
    </Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/pages/news-crawler/libraries/table.tsx